import React from 'react';
import Link from 'next/link'
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi'

type ConnectAccountProps = {
    variant?: 'full' | 'compact';
    buttonClassName?: string;
};

export default function ConnectAccount({
    variant = 'full',
    buttonClassName,
}: ConnectAccountProps) {
    const { openConnectModal } = useConnectModal();
    const account = useAccount()
    const isConnected = account.isConnected

    const buttonClasses =
        buttonClassName ??
        (variant === 'compact'
            ? 'px-4 py-2 rounded-full font-semibold text-xs bg-blue-600 text-white hover:bg-blue-700 transition-colors'
            : 'my-6 py-3 px-6 rounded-xl bg-emerald-600 text-white shadow-sm hover:bg-emerald-500 transition');

    const handleConnectWalletClick = (event: any) => {
        console.log(`user did click to connect wallet`)
        if (openConnectModal) {
             openConnectModal()
        }else{
            console.log(`openConnectModal is not available`)
        }
    }

    if (isConnected) {
        if (variant === 'compact') {
            return null;
        }
        return (
            <div className='w-full'>
                <div className='mt-6'>
                    <p className='break-words text-center'>
                        <span className='whitespace-nowrap'>Base account:</span>
                        {' '}
                        <span className='break-all text-sm font-mono'>
                            {account.address}
                        </span>
                    </p>
                </div>
            </div>
        )
    }

    if (variant === 'compact') {
        return (
            <div>
                {openConnectModal && (
                    <button onClick={handleConnectWalletClick} className={buttonClasses}>
                        Connect Wallet
                    </button>
                )}
            </div>
        );
    }

    return(
        <div>
            <div className='mt-6 p-2'>
                Connect an account on the
                <Link href="https://www.base.org/about" target="_new" className='text-slate-900 p-1 underline'>Base</Link>
                blockchain to publish Stickers and receive payments when they are slapped.
            </div>

            <div className='mt-0'>
                {openConnectModal && (
                <button onClick={handleConnectWalletClick} className={buttonClasses}>
                    Connect Wallet
                </button>
                )}
            </div>

            <div className='text-sm'>
                Need a Base account? Try
                <Link
                    href="https://rabby.io/"
                    target="_blank"
                    rel="noreferrer"
                    className='text-slate-900 pl-1 underline'
                >
                    Rabby
                </Link>
                ,
                <Link
                    href="https://www.coinbase.com/wallet/downloads"
                    target="_blank"
                    rel="noreferrer"
                    className='text-slate-900 pl-1 underline'
                >
                    Coinbase Wallet
                </Link>
                , or
                <Link
                    href="https://rainbow.me/"
                    target="_blank"
                    rel="noreferrer"
                    className='text-slate-900 pl-1 underline'
                >
                    Rainbow
                </Link>
                .
            </div>
        </div>
    )

}
